import {UISprite} from "../Base/UISprite";
import {UINineSlice} from "../Base/UINineSlice";
import {UIText} from "../Base/UIText";
import {Core} from "../../../Base/Core";
import {MissionReward} from "./MissionReward";

export class MissionRewards extends UISprite {
    Awake() {
        super.Awake();

        this.back = this.addChild(new UINineSlice("bg-simple"));
        this.back.tint = 0x000000;
        this.back.alpha = 0.3;

        this.title = this.addChild(new UIText(Core.Localizator.Get("mission_rewards")));
        this.items = [];
    }

    Init(rewards) {
        while (this.items.length > rewards.length) this.removeChild(this.items.pop());
        for (let i = 0; i < rewards.length; i++) {
            let item = this.items[i] || this.addChild(new MissionReward());
            item.Init(rewards[i]);
            if (this.items.length <= i) {
                this.items.push(item);
            }
        }
    }

    UpdateUI() {
        for (let item of this.items) {
            item.UpdateUI();
        }
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);

        let rect = parentRect.clone();
        rect.x = rect.y = 0;
        this.back.fitLayout(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.22;
        rect.height = parentRect.height * 0.6;
        rect.x = parentRect.width * 0.05;
        rect.y = (parentRect.height - rect.height) * 0.5;
        this.title.fitLayout(rect);

        let itemSize = parentRect.width * 0.2;
        rect.x = parentRect.width * 0.95;
        let reversed = this.items.reverse();
        for (let item of reversed) {
            rect.width = item.label ? itemSize : itemSize * 0.75;
            rect.x -= rect.width;
            item.fitLayout(rect);
        }
    }
}
